<template>
<transition type="animation"
    appear
    enter-active-class="animate__animated animate__fadeIn"
    mode="in-out"
>
    <div v-if="temPermissao('segmento-infantil')" class="main" id="about-main">
        <b-container fluid="lg">
            <b-card no-body class="shadow-sm card_sistemacpv p-4">
                <b-row no-gutters>
                    <b-col cols="12" md="6" lg="4" xl="3" v-for="(pdf, index) in lists" :key="index">
                        <b-link :to="pdf.link_name">
                            <b-card class="card-link shadow-sm border-0" :class="pdf.bg__link" :style="pdf.colorCard" no-body>
                                <p class="text-center"><i :class="pdf.iconClass"></i></p>
                                <h5 class="text-center text-uppercase font-weight-bolder text-white">{{ pdf.title }}
                                </h5>
                                <p class="text-center text-white">{{ pdf.text }}</p>
                                <div class="corner d-none d-md-none d-lg-flex">
                                    <div class="arrow">
                                        <i class="fa-solid fa-arrow-right"></i>
                                    </div>
                                </div>
                            </b-card>
                        </b-link>
                    </b-col>
                </b-row>
            </b-card>
        </b-container>
    </div>

    <div v-else>
        <div class="container">
            <div class="text-center">
                {{ error503 }}
                <p>Você não tem permissão para visualizar este conteúdo.</p>
            </div>

        </div>
    </div>
</transition>
</template>

    
    
  <script>  
import HeaderSistema from '@/components/GlobalComponents/jumbotron-header';
import BreadSistema from '@/components/GlobalComponents/bread-sistema';
export default {
    name: 'dash-infantil',

    data() {
        return {
            pageTitle: 'EDUCAÇÃO INFANTIL',
            pageSubtitle: 'MANUAL PROFESSORES / COORDENADORES',
            NamePermission: '',
            IndexPermission: '',

            lists: [{
                    title: 'Infantil 2',
                    text: '(Maternal I)',
                    link_name: 'maternal-i',
                    // iconClass: 'fa-regular fa-book fa-3x',
                    colorCard: {
                        'background-color': '#38aaf3',
                        'border:': '1px solid #38aaf3',
                        'border-radius': '0.5rem',
                    },
                    permission: 'segmento-infantil',
                    bg__link: 'infantil',
                },
                {
                    title: 'Infantil 3',
                    text: '(Maternal II)',
                    link_name: 'maternal-ii',
                    // iconClass: 'fa-light fa-calendar-days fa-3x',
                    colorCard: {
                        'background-color': '#4ac8aa',
                        'border:': '1px solid #4ac8aa',
                        'border-radius': '0.5rem',
                    },
                    permission: 'segmento-infantil',
                    bg__link: 'fundamental-i',
                },
                {
                    title: 'Infantil 4',
                    text: '(Jardim I)',
                    link_name: 'jardim-i',
                    // iconClass: 'fa-regular fa-notebook fa-3x',
                    colorCard: {
                        'background-color': '#a7dc48',
                        'border:': '1px solid #a7dc48',
                        'border-radius': '0.5rem',
                    },
                    permission: 'segmento-infantil',
                    bg__link: 'fundamental-ii',
                },
                {
                    title: 'Infantil 5',
                    text: '(Jardim II)',
                    link_name: 'jardim-ii',
                    // iconClass: 'fa-regular fa-music fa-3x',
                    colorCard: {
                        'background-color': '#fc5b5b',
                        'border:': '1px solid #fc5b5b',
                        'border-radius': '0.5rem',
                    },
                    permission: 'segmento-infantil',
                    bg__link: 'medio',
                },
            ],
        };
    },
    created() {
        this.$emit('update-header', {
            title: this.pageTitle,
            subtitle: this.pageSubtitle
        });
    },
    computed: {

        permissions() {
            return this.$store.state.auth.userpermissions.permissions;
        },
        error503() {

            return (window.location.href = '/nao-autorizado');

        },

    },

    methods: {
        temPermissao(permissao) {
            return this.permissions.includes(permissao);
        },
    }

};
</script>
    
    
 <style scoped> 
.main {
  margin-top: 30px;
}

.card_sistemacpv {
  border-radius: 8px;
  color: #3A1C53;
}
</style>
